import { render, staticRenderFns } from "./ClaimDialog.vue?vue&type=template&id=769cdaf8&"
import script from "./ClaimDialog.vue?vue&type=script&lang=js&"
export * from "./ClaimDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports